import React, { Component } from "react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { s360ConfigService } from "../../Services/S360Config";
import DayjsUtils from '@date-io/dayjs';
import dayjs from "dayjs";
import { dateByAdding } from "../../HWLibrary/HWUtils";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
class MessageA5 extends Component {

  constructor(props) {
    super(props);
    let dateInputs = this.parseDateInputs(props);
    this.state = { dateInputs: dateInputs, selectedDate: dateInputs.maxDate || new Date() }
  }

  render() {
    let displayText = this.props.entry.text;
    return (
      <div className="s360-message-cotainer-received">
        <div className="s360-message-box-custom-a14-received" style={this.messageBoxStyle()}>
          {displayText && <div>{displayText}</div>}
          <div style={{padding: "10px"}}>
            <MuiPickersUtilsProvider locale="nl" utils={DayjsUtils}>
            <ThemeProvider theme={this.materialTheme}>
              <KeyboardDatePicker allowKeyboardControl={false}
                autoOk  {...this.state.dateInputs} variant="inline" label="" format="DD/MM/YY" value={this.state.selectedDate} helperText="" onChange={this.onDateSelect} />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </div>
        </div>
        {this.props.isLastEntry && this.props.sentTimestamp && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.sentTimestamp).format("h:mm a")}</div>}
      </div>
    );
  }
  
  parseDateInputs = (props) => {
    let dateInputs = {};
    if (props.entry.data) {
      let data = JSON.parse(props.entry.data)
      if (data.from_day) { dateInputs.minDate = dateByAdding(data.from_day); }
      if (data.to_day)   { dateInputs.maxDate = dateByAdding(data.to_day);  }
    }
    return dateInputs;
  }

  messageBoxStyle = () => {
    return { background: s360ConfigService.config.designDetails.senderMessageColor, fontFamily: s360ConfigService.config.designDetails.SenderMessageFont, fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize, color: s360ConfigService.config.designDetails.senderMessageFontColor }
  }

  onDateSelect = (selectedDate) => {
   this.setState({ selectedDate: selectedDate });
   this.props.actions.sendMessage(dayjs(selectedDate).format("DD/MM/YY"));
  }

  materialTheme = createMuiTheme({
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: s360ConfigService.config.designDetails.recieverMessageColor,
        },
      },

      MuiPickersDay: {
        day: {
          color: s360ConfigService.config.designDetails.recieverMessageColor,
        },
        daySelected: {
          backgroundColor: s360ConfigService.config.designDetails.recieverMessageColor,
        },
        dayDisabled: {
          color: s360ConfigService.config.designDetails.senderMessageColor,
        },
        current: {
          color: s360ConfigService.config.designDetails.recieverMessageColor,
        },
      },
      MuiPickersModal: {
        dialogAction: {
          color: s360ConfigService.config.designDetails.recieverMessageColor,
        },
      },
    },
  });

}

export default MessageA5;